export default "__VITE_ASSET__CJOi8dgu__"